import {LOGIN_USER, LOGIN_USER_ERROR, LOGIN_USER_SUCCESS, LOGOUT_USER, LOGOUT_USER_SUCCESS} from "./actionTypes";

const initialState = {
    error: null,
    loading: false
};

const login = (state = initialState, action) => {
    switch (action.type) {
        case LOGIN_USER:
            state = {
                ...state,
                loading: true
            };
            break;
        case LOGIN_USER_SUCCESS:
            state = {
                ...state,
                error: null,
                loading: false
            };
            break;
        case LOGIN_USER_ERROR:
            state = {
                ...state,
                error: action.payload,
                loading: false
            };
            break;
        case LOGOUT_USER:
            state = {...state};
            break;
        case LOGOUT_USER_SUCCESS:
            state = {...state};
            break;
        default:
            state = {...state};
            break;
    }
    return state;
};

export default login;